var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCapi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 86,
    viewBox: "0 0 73 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: 7,
    fill: "#FFDCE3",
    fillRule: "nonzero",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7465F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M.5 25c0-2.21 2.29-4 4.5-4h23M49.9 51.69v26.551c0 2.21.31 5.759-1.9 5.759H2.309C.099 84 .5 80.451.5 78.241L0 33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    fillRule: "nonzero",
    d: "M43.495 22.601a3 3 0 1 0-3-5.196 3 3 0 0 0 3 5.196z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.998,
    cy: 31.995,
    r: 3,
    fill: "#F7465F",
    fillRule: "nonzero",
    transform: "rotate(-30 53.998 31.995)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#F7465F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M41 33l14-14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7465F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M10 62h32M10 56h15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 26,
    r: 19,
    stroke: "#F7465F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.67
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCapi);
export default __webpack_public_path__ + "static/media/ic-capi.27d5aaf384aca21f5ed68cad0f04fd7d.svg";
export { ForwardRef as ReactComponent };